import { Box, Typography } from "@mui/material";
import { useTranslation } from "hhn-commons";
import { IBroadcastInfo, IGroupInfo } from "@home-health-notify/domain";

export const About = ({
  groupInfo,
}: {
  groupInfo: IGroupInfo | IBroadcastInfo;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  return (
    <Box sx={{ padding: "20px" }}>
      <Typography sx={{ marginBottom: "20px" }}>{tNs("about")}</Typography>
      <Typography data-testid="about-group" sx={{ whiteSpace: "pre-wrap" }}>
        {groupInfo.about ? groupInfo.about : "N/A"}
      </Typography>
    </Box>
  );
};
